/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/botaniskabaren/"

const BOTANISKA_BAREN: CommunityData = {
  code: "botaniskabaren",
  inviteCode: "botaniskabaren",
  name: "Botaniska Baren",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bot-090`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#b5ffbd",
      logo: {
        src: `https://media.werz.at/community/icon/cmobi2bmq00009kabl17a9ko4.jpg?uploadTime=1776956207597&type=image`,
        styles: "w-[170px] h-[64px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[170px] h-[64px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#123015",
      asideBg: "#123015",
      asideStyles: "!p-0 !gap-0 border-r border-[#b5ffbd40]",
      contentBg: "#123015",
      contentBoxShadow: "rounded-[24px]",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['BricolageGrotesqueRegular']",
      primaryButton:
        "bg-[#b5ffbd] border border-[#b5ffbd] px-[18px] py-[18px] !text-[#123015] font-['BricolageGrotesqueBold'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#b5ffbd",
      sideBarSeparator: "border-r-[1px] border-[#b5ffbd40]",
      separator: "border-[#b5ffbd40]",
      item: "font-['BricolageGrotesqueRegular'] text-[16px] text-[#b5ffbd] leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#b5ffbd40] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#123015] rounded-[24px] !pb-8",
      titles:
        "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[30px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#b5ffbd40]",
        sectionTitle:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[30px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#123015]",
          mediaContainer:
            "w-full sm:w-[256px] !aspect-square relative rounded-[12px] overflow-hidden",
          media: "w-full !aspect-square object-cover rounded-[12px] !border-0",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-[12px]",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#b5ffbd40]",
        sectionTitle:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[30px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#123015]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative rounded-[12px] overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-[12px] !border-0",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-[12px]",
          content: "flex flex-col py-4 sm:px-4 sm:py-0 bg-transparent",
          title:
            "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[18px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[30px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#123015] rounded-[24px] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#b5ffbd40]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-[12px]",
        title:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[30px] text-left leading-[110%]",
        subtitle:
          "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#b5ffbd] border border-[#b5ffbd] rounded-full px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#123015] font-['BricolageGrotesqueBold'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[130%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#b5ffbd40]",
        header:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#b5ffbd40]",
        header:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] rounded-[12px]",
        mapPinColor: "#305934",
        mapStrokeColor: "#305934",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[24px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#123015] rounded-[24px] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#123015] border border-[#b5ffbd] rounded-full px-[12px] py-[12px] text-[#b5ffbd] font-['BricolageGrotesqueBold'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#123015] border-b border-[#b5ffbd40] sm:py-4 py-2",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#b5ffbd] font-['BricolageGrotesqueExtraBold'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#ffffff] font-['BricolageGrotesqueRegular'] text-[14px] text-left leading-[130%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['BricolageGrotesqueExtraBold'] text-[16px] text-left leading-[110%]",
          quantity:
            "text-[#b5ffbd] font-['BricolageGrotesqueBold'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['BricolageGrotesqueExtraBold'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#123015] border border-[#b5ffbd] rounded-full px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#123015] border border-[#b5ffbd] rounded-full px-[12px] py-[12px] text-[#b5ffbd] font-['BricolageGrotesqueBold'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#b5ffbd",
        },
      },
    },
  },
}

export default BOTANISKA_BAREN
